import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeGetCompanyCreditsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BackofficeGetCompanyCreditsResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getBackofficeOrganizationCreditsQueryKey = (id: string) => [
  "backofficeOrganizationCredits",
  id,
]

type Props = {
  id: string
  onSuccess?: OnSuccessFn
}

export const getBackofficeOrganizationCreditsQuery = ({ id, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeOrganizationCreditsQueryKey(id),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/organizations/${id}/credits`)
      onSuccess?.(data)
      return data.data
    },
  })
}
